import { reactive } from 'vue'

// ! global state for Lead  

const state = reactive({
    editBool: false,
    data: null,
})


export default {
    state
}